import ReactSpeedoMeter, {
    Props,
    CustomSegmentLabel,
    CustomSegmentLabelPosition,
    Transition,
} from 'react-d3-speedometer';
import { useSelector } from 'react-redux';
import { RootStateType } from '../../redux-store/reducers';
import { Risks } from '../../redux-store/types/newPurchase';

interface RiskMeterProps extends Props {
    headerTitle?: string;
    risk?: Risks;
}
enum Colors {
    Low = 'rgb(131 197 6)',
    Low_To_Moderate = 'rgb(188 208 4)',
    Moderate = 'rgb(236 175 3)',
    Moderatly_High = 'rgb(235 143 60)',
    High = 'rgb(212 75 76)',
    Very_High = 'rgb(192 46 46)',
}

const riskValues: any = {
    [Risks['Principal at low risk']]: {
        color: Colors.Low,
    },
    [Risks['Principal at high risk']]: {
        color: Colors.High,
    },
    [Risks['Principal at very high risk']]: {
        color: Colors.Very_High,
    },
    [Risks['Principal at moderate risk']]: {
        color: Colors.Moderate,
    },
    [Risks['Principal at moderately low risk']]: {
        color: Colors.Low_To_Moderate,
    },
    [Risks['Principal at moderately high risk']]: {
        color: Colors.Moderatly_High,
    },
};
const SVG_WIDTH = 300;
const svgPadding = 10;
const eachSegmentWidth = SVG_WIDTH / 6;
const styles = [
    {
        bottom: -(SVG_WIDTH / 2 - svgPadding),
        left: 0,
    },
    {
        bottom: -(eachSegmentWidth * 2 - 1 * 30),
        left: 0,
    },
    {
        bottom: eachSegmentWidth * 1 - 2 * 30,
        left: SVG_WIDTH / 2 - eachSegmentWidth,
    },
    {
        bottom: eachSegmentWidth * 1 - 2 * 30,
        left: SVG_WIDTH / 2 + 1 * eachSegmentWidth,
    },
    {
        bottom: -(eachSegmentWidth * 2 - 1 * 30),
        left: SVG_WIDTH / 2 + 2 * eachSegmentWidth + svgPadding,
    },
    {
        bottom: -(SVG_WIDTH / 2 - svgPadding),
        left: SVG_WIDTH / 2 + 3 * eachSegmentWidth,
    },
];

const segmentPointMultiplier = 5;

const RiskMeter = ({
    headerTitle = 'Scheme Riskometer',
    risk = Risks.Low,
    ...props
}: RiskMeterProps) => {
    const {
        masterData: { riskCategories = [] },
    } = useSelector(({ newPurchase }: RootStateType) => ({ ...newPurchase }));
    const _risks: CustomSegmentLabel[] = riskCategories.map(({ id, name }) => ({
        position: CustomSegmentLabelPosition.Outside,
        text: '',
        fontSize: '12px',
        color: 'black',
    }));

    return (
        <div
            className="risko-meter"
            style={{
                background: ' #fafcff',
                border: '1px solid #e5e8ea',
                borderRadius: 10,
                padding: 25,
                transition: 'none',
            }}
        >
            <h4 style={{ marginBottom: 30 }}>{headerTitle}</h4>
            <div className="risko-meter-content" style={{ textAlign: 'center' }}>
                <div className="risko-meter-text" style={{ position: 'relative', marginLeft: 40 }}>
                    {riskCategories.map((ele, index) => (
                        <div
                            style={{
                                color:
                                    risk === '10' && ele.id === '5'
                                        ? riskValues[5].color
                                        : risk === ele.id
                                            ? riskValues[Number(risk)].color
                                            : '',
                                bottom: styles[index].bottom,
                                left: styles[index].left,
                            }}
                            className={`risk__label1`}
                        >
                            {ele.name}
                        </div>
                    ))}
                </div>
                <ReactSpeedoMeter
                    needleHeightRatio={0.7}
                    customSegmentStops={[3, 4, 5, 6, 7, 8, 9].map(
                        (ele) => ele * segmentPointMultiplier,
                    )}
                    maxSegmentLabels={6}
                    value={
                        (risk === '10' ? 5 : Number(risk)) * segmentPointMultiplier -
                        segmentPointMultiplier / 2
                    } // to make to needle center aligned
                    minValue={15}
                    maxValue={45}
                    currentValueText=" "
                    customSegmentLabels={_risks}
                    ringWidth={47}
                    needleTransitionDuration={500}
                    needleTransition={Transition.easeLinear}
                    needleColor={'#311560'}
                    textColor={'#d8dee9'}
                    segments={_risks.length}
                    segmentColors={[
                        Colors.Low,
                        Colors.Low_To_Moderate,
                        Colors.Moderate,
                        Colors.Moderatly_High,
                        Colors.High,
                        Colors.Very_High,
                    ]}
                    {...props}
                />
            </div>
        </div>
    );
};
export default RiskMeter;
